require('styles/common/util.scss');
require('styles/common/common1.scss');
require('plugins/Font-Awesome/css/all.min.css');
require('plugins/swiper/dist/css/swiper.min.css');
require('plugins/malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.min.css');
require('styles/pages/xiaoguotu-detail.scss');

require('script!jquery');
require('../common/form-validation.coffee');
require('script!ajaxform');
require('script!sweetAlert');
require('lazyload');
require('script!affix');
require('script!plugins/swiper/dist/js/swiper.jquery.js');
require('script!plugins/jquery-mousewheel');
require('script!plugins/malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js');
require('../common/city.coffee');

$(function () {
  "use strict";

  $("img.lazyload").lazyload();
  var galleryTop, galleryThumbs, setCheckedImg;

  setCheckedImg = function (index) {
    galleryTop.activeIndex !== index && galleryTop.slideTo(index);
    galleryThumbs.activeIndex !== index && galleryThumbs.slideTo(index);
    if (!$('.gallery-thumbs .swiper-slide .img').eq(index).hasClass('checked')) {
      $('.gallery-thumbs .swiper-slide .img').removeClass('checked');
      $('.gallery-thumbs .swiper-slide .img').eq(index).addClass('checked');
      $('.pagination-number .index').html(index + 1);
      $('.pagination-number .total').html($('.gallery-thumbs .swiper-slide').length);
      var title = $('.gallery-thumbs .swiper-slide .img').eq(index).data('title');
      var desc = $('.gallery-thumbs .swiper-slide .img').eq(index).data('desc');
      $('.gallery .detail-head .title').html(title);
      $('.gallery .detail-footer .desc').html(desc);
    }
  };

  galleryTop = new Swiper('.gallery-top', {
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    spaceBetween: 20,
    onSlideChangeStart: function (swiper) {
      var index = swiper.activeIndex;
      setCheckedImg(index);
    }
  });


  galleryThumbs = new Swiper('.gallery-thumbs', {
    nextButton: '.thumbnail .swiper-button-next',
    prevButton: '.thumbnail .swiper-button-prev',
    spaceBetween: 18,
    centeredSlides: false,
    slidesPerView: 'auto',
    noSwiping: true,
    simulateTouch: false,
    onSlideChangeStart: function (swiper) {
      var index = swiper.activeIndex;
      setCheckedImg(index);
    },
  });

  $('.gallery-thumbs .swiper-slide').click(function () {
    var index = $(this).index();
    setCheckedImg(index);
  });
  setCheckedImg(0);
});

$(function () {
  "use strict";

  var $detail = $('#xiaoguotu-detail .info p.detail');
  if($detail[0].clientWidth < $detail[0].scrollWidth) {
    $detail.addClass('overflow');
  }
  var $show = $detail.find('.show-btn');
  $show.click(function () {
    $detail.toggleClass('show-all');
  });
  $('.mC').mCustomScrollbar();
  
});

$(function () {
  "use strict";

  var $forms = $('main form');
  $forms.each(function (inde, form) {
    var $form = $(form);

    $form.validate({
      errorPlacement: function (error) {
        return swal({
          title: error[0].innerHTML,
          allowOutsideClick: false
        });
      },
      submitHandler: function (form) {
        var phoneNumber, userId;
        phoneNumber = form.elements.mobile.value.trim();
        userId = 'MOBI' + phoneNumber + '}';

        $(form).ajaxSubmit({
          dataType: 'json',
          data: {
            rnd: parseInt(Math.random() * 1e7, 10) + (new Date()).getTime()
          },
          error: function () {
            return swal({
              title: '对不起，出错了，请稍后重试！',
              allowOutsideClick: true
            });
          },
          success: function (res) {
            if (res.msg && res.msg[0] && res.msg[0].type === 'success') {
              // swal({
              //   title: '预约成功，我们会在一个工作日内联系您~',
              //   allowOutsideClick: true
              // });
              swal({
                customClass: 'alert-success',
                title: '<img class="form_success" src="'+$('#alertImg').attr('src')+'" alt="">',
                confirmButtonText: '返  回',
                confirmButtonColor: '#3b9bff',
                allowOutsideClick: true,
                html: true
              });
            }
            if (res.msg[0].type === 'error') {
              swal({
                title: res.msg[0].info,
                allowOutsideClick: true
              });
              return false;
            }
            if (res.msg[0].type === 'error') {
              swal({
                title: res.msg[0].info,
                allowOutsideClick: true
              });
              return false;
            }
          }
        });
      }

    });


    var elements = form.elements;
    // var effectives = [];

    for (var i = 0; i < elements.length; i++) {
      var element = elements[i];
      var name = $(element).attr('name');
      if (name) {
        // effectives.push(element);
        var $elm = $(element);
        $elm.rules('add', {
          // required: Boolean($elm.attr('required')),
          mobileNum: Boolean($elm.attr('mobile')),
          messages: {
            required: $elm.data('required'),
            mobileNum: $elm.data('mobile')
          }
        });
      }
    }
  });
});


/*****************
 ** WEBPACK FOOTER
 ** ./xiaoguotu-detail.js
 ** module id = 0
 ** module chunks = 1
 **/